<template>
  <div class="data-grid__selectFilter">
    <multiselect
      v-model="selected"
      :options="selectOptions"
      :multiple="true"
      :close-on-select="false"
      :clear-on-select="false"
      :preserve-search="true"
      label="text"

      selectLabel=""
      selectedLabel=""
      tagPlaceholder=""
      placeholder=""
      deselectLabel=""

      track-by="value"
      openDirection="bottom"
      @select="select"
      @remove="select"
    />
  </div>
</template>

<script>
import Vue from 'vue'

export default {
  props: ['cellKey', 'filter', 'options'],
  data () {
    return {
      selected: []
    }
  },
  computed: {
    selectOptions () {
      const options = []

      const dbOptions = this.$getDGFBControl(this.options.rowEditorFieldsForm, this.cellKey).dataOptions

      if (dbOptions) {
        for (let option of dbOptions) {
          options.push({ value: option.id, text: option.text })
        }
      }

      return options
    }
  },
  methods: {
    select () {
      this.$nextTick(() => {
        if (this.selected.length) Vue.set(this.filter, this.cellKey, this.selected)
        else Vue.delete(this.filter, this.cellKey)
      })
    }
  }
}
</script>
